"use client"

import Image from "next/image"
import { Divider } from "@heroui/divider"

import howtosearch from "@/assets/howtosearch.png"
import howtosearchmobile from "@/assets/howtosearchmobile.png"

export default function PageClient() {
  const handleWeb = () => {
    window.open("https://snaptheprice.com/", "_blank")
  }
  const handleExtension = () => {
    window.open(
      "https://chromewebstore.google.com/detail/snaptheprice/hlnhhamckimoaiekbglafiebkfimhapb",
      "_blank"
    )
  }
  return (
    <div className="flex-col items-center px-3 pt-4 text-[#1D2129] sm:px-[120px] sm:pt-10">
      <div className="mb-3 text-[24px] font-bold sm:text-[36px]">
        How to Install the SnapThePrice Extension
      </div>
      <div className="mb-6 sm:mb-[40px]">
        To enjoy the full power of SnapThePrice while shopping on your computer,
        you’ll first need to install the extension in your Chrome browser. Don’t
        worry—it only takes a few clicks! Below are three simple ways you can
        install it:
      </div>
      <div className="opacity-100">
        <Divider />
      </div>
      <div className="justify-center gap-[24px] pt-6 sm:flex sm:pt-10">
        <div className="sm:w-[49%]">
          <div className="flex flex-col items-center">
            <div className="text-[20px] font-bold text-[#0F9E4F]">Method 1</div>
            <div className="mt-3 mb-4 text-[24px] font-bold sm:mb-6">
              Install via the Official Website
            </div>
          </div>
          <video
            src="/video/methodone.mp4"
            autoPlay
            // muted
            loop
            controls
            style={{ width: "100%", borderRadius: "8px" }}
          />
          <div className="mt-4 mb-2 sm:mt-6">
            1. Open your browser and go to{" "}
            <span
              onClick={handleWeb}
              className="cursor-pointer text-[#135BFF] underline"
            >
              SnapThePrice.com.
            </span>
          </div>
          <div className="mb-2">
            2. Click the <span className="text-[#135BFF]">“Get Extension”</span>{" "}
            or similar button on the homepage.
          </div>
          <div className="mb-2">
            3. You’ll be redirected to the{" "}
            <span className="text-[#135BFF]">
              Chrome Web Store SnapThePrice page.
            </span>
          </div>
          <div className="mb-4 sm:mb-6">
            4. Click <span className="text-[#135BFF]">“Add to Chrome”</span> and
            confirm the installation.
          </div>
          <div className="mb-6 sm:mb-8">
            Once installed, you’ll see the SnapThePrice icon appear in your
            browser’s toolbar.
          </div>
        </div>
        <div className="sm:w-[49%]">
          <div className="flex flex-col items-center">
            <div className="text-[20px] font-bold text-[#0F9E4F]">Method 2</div>
            <div className="mt-3 mb-4 text-[24px] font-bold sm:mb-6">
              Search Directly in the Chrome Web Store
            </div>
          </div>
          <video
            src="/video/methodtwo.mp4"
            autoPlay
            // muted
            loop
            controls
            style={{ width: "100%", borderRadius: "8px" }}
          />
          <div className="mt-4 mb-2 sm:mt-6">
            1. Open Chrome and go to the{" "}
            <span
              onClick={handleExtension}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Chrome Web Store.
            </span>
          </div>
          <div className="mb-2">
            2. In the search bar, type{" "}
            <span className="text-[#135BFF]">“SnapThePrice.”</span>{" "}
          </div>
          <div className="mb-2">
            3. Find the SnapThePrice extension in the search results and click
            it.
          </div>
          <div className="mb-2">
            4. On the extension’s detail page, click{" "}
            <span className="text-[#135BFF]">“Add to Chrome”</span>
          </div>
          <div className="mb-2">5. Confirm, and you’re all set!</div>
        </div>
      </div>
      <div className="opacity-0 sm:opacity-100">
        <Divider />
      </div>
      <div className="mt-6 mb-1 text-[20px] font-bold sm:mt-[40px] sm:mb-3">
        Final Thoughts
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        After installation, make sure SnapThePrice is always visible:
      </div>
      <div className="mb-2 text-[14px]">
        1. Click the puzzle-shaped Extensions icon in the top-right corner of
        Chrome.
      </div>
      <div className="mb-2 text-[14px]">2. Find SnapThePrice in the list.</div>
      <div className="mb-6 text-[14px] sm:mb-10">
        3. Click the Pin icon to keep it fixed in your toolbar for quick access.
      </div>
      <div className="mt-6 mb-1 text-[20px] font-bold sm:mt-[40px] sm:mb-3">
        Summary
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        There are three easy ways to install SnapThePrice:
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">From the official website.</li>
        <li className="mb-2">By searching in the Chrome Web Store.</li>
        <li className="mb-2">
          By searching on Google and choosing the official link.
        </li>
      </ul>
      <div className="mb-2 text-[14px] sm:mb-6">
        Once installed, don’t forget to pin the extension so you can snap the
        lowest price anytime you shop online! 🚀
      </div>
    </div>
  )
}
